<ideal-image image *renderInProductResult="LayoutTargets.Images" [src]="thumbnailUrl()" [attr.layout]="layout()"></ideal-image>

<ideal-product-id-label product-id [productId]="id()" *renderInProductResult="LayoutTargets.Title"></ideal-product-id-label>

<ideal-product-short-description
  description
  [productId]="id()"
  [maxLines]="layout() === 'row' ? 3 : 2"
  [attr.line]="layout() === 'row'"
  *renderInProductResult="LayoutTargets.Title"
></ideal-product-short-description>

<ideal-product-is-canadian
  canadian
  [productId]="id()"
  *renderInProductResult="LayoutTargets.ImagesOverlay"
  class="canadian"
></ideal-product-is-canadian>

<ng-container *renderInProductResult="LayoutTargets.Stock">
  <ideal-item-stock-button [itemId]="id()" />
</ng-container>

<ng-container *renderInProductResult="LayoutTargets.Price">
  <ideal-item-price [itemId]="itemId()" sizing="fixed" disableCallForPrice="true" layout="horizontal" usePricePer="unit"></ideal-item-price>
</ng-container>
